import type { HTMLAttributes } from 'react'
import { cn } from '@/shared/lib'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  accent?: boolean
  interactive?: boolean
}

export function Card({
  accent = false,
  interactive = false,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    // Без бордера: контраст поверхности достаточен, рамка — лишний шум.
    // py < px: верх/низ добирают высоту полулидингом первой/последней строки,
    // одинаковые паддинги смотрятся толще по вертикали, чем слева.
    <div
      className={cn(
        'rounded-card bg-bg-surface px-6 py-5',
        accent && 'ring-1 ring-border-accent ring-inset',
        interactive && 'transition-colors hover:bg-bg-raised',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
